import React, { Fragment, useState } from 'react';
import { connect } from 'react-redux';
import * as actions from '../../../../../store/actions';
import { Grid, Typography } from '@material-ui/core';
import SelectorAnioFiscalDos from './SelectorAnioFiscalDos';
import SelectorArchivoDos from './SelectorArchivoDos';
import classes from './ImportadorBudgetForecastDos.css';
import { Tooltip, IconButton } from '@material-ui/core';
import BookIcon from '@material-ui/icons/Book';
import IconConvertToExcel from '../../../../../assets/images/IconConvertToExcel.png';
import ImportadorBudgetForecastDosPDF from '../../../../../assets/documents/Importador2BudgetForecast.pdf';
import TemplateUnidadesBudgetForecastXLSX from '../../../../../assets/documents/TemplateUnidadesBudgetForecast.xlsx';
import TemplatePorcentajesBudgetForecastXLSX from '../../../../../assets/documents/TemplatePorcentajesBudgetForecast.xlsx';
import TemplateInflacionBudgetForecastXLSX from '../../../../../assets/documents/TemplateInflacionBudgetForecast.xlsx';

const ImportadorBudgetForecastDos = (props) => {
  const [anioFiscal, setAnioFiscal] = useState('');
  const [isSelectorArchivoVisible, setIsSelectorArchivoVisible] = useState(false);

  const onAnioFiscalChanged = (anio) => {
    if (anio !== null) {
      setAnioFiscal(anio.id);
      setIsSelectorArchivoVisible(true);
    }
    else {
      setAnioFiscal('');
      setIsSelectorArchivoVisible(false);
    }
  }

  const openInNewTab = url => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  const title = () => {
    return (
      <Typography variant="h5">
        IMPORTADOR BUDGET FORECAST - INFORME 2
        
        <Tooltip title="Plantilla Excel Unidades">
          <IconButton size="large" style={{marginLeft: 20}} onClick={() => openInNewTab(TemplateUnidadesBudgetForecastXLSX)}>
            <img alt="" src={IconConvertToExcel} height={'43px'} />
          </IconButton>
        </Tooltip>

        <Tooltip title="Plantilla Excel % Distribución">
          <IconButton size="large" style={{marginLeft: 20}} onClick={() => openInNewTab(TemplatePorcentajesBudgetForecastXLSX)}>
            <img alt="" src={IconConvertToExcel} height={'43px'} />
          </IconButton>
        </Tooltip>

        <Tooltip title="Plantilla Excel Inflación">
          <IconButton size="large" style={{marginLeft: 20}} onClick={() => openInNewTab(TemplateInflacionBudgetForecastXLSX)}>
            <img alt="" src={IconConvertToExcel} height={'43px'} />
          </IconButton>
        </Tooltip>

        <Tooltip title="Manual de usuario">
          <IconButton size="large" style={{marginLeft: 20}} onClick={() => openInNewTab(ImportadorBudgetForecastDosPDF)}>
            <BookIcon style={{ color: '#696969' }} fontSize="large" />
          </IconButton>
        </Tooltip>
      </Typography>
    )
  }

  const subTitle = () => {
    return (
      <Fragment>
        <Grid container spacing={1} 
          direction="column" justifyContent="flex-start"
          style={{ marginTop: '10px' }}
        >
          <Grid item xs={12} md={11} container>
            <Grid item xs={12} md={8}>
              <SelectorAnioFiscalDos anioFiscalChangedCallback={onAnioFiscalChanged} />
            </Grid>

            {isSelectorArchivoVisible && (
              <Grid item xs={12} md={11}>
                <hr />
                <SelectorArchivoDos anioFiscal={anioFiscal} />
              </Grid>
            )}
          </Grid>
        </Grid>
      </Fragment>
    )
  }

  return (
    <Grid container
      style={{ height: "100%", width: "95vw", minHeight: 500, 
        border: "0px solid #ccc", boxShadow: "0px 3px 6px #00000029",
        backgroundColor: "white", borderRadius: "3px" }}
    >
      <Grid item xs={12}
        container spacing={1}
        direction='row' justifyContent='space-between' alignContent='flex-start'
      >
        <Grid item xs={9} md={10} 
          container className={classes.TitleContainer}
          style={{ margin: 'auto', marginLeft: '20px' }}>
          <Grid item xs={12} className={classes.Title}>
            {title()}
          </Grid>
          <Grid item xs={12} className={classes.Subtitle}>
            {subTitle()}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}
  
const mapStateToProps = () => { return {}; };

const mapDispatchToProps = () => { return {}; };

export default connect(mapStateToProps, mapDispatchToProps)(ImportadorBudgetForecastDos);